import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './StarsBar.scss';
import classNames from 'classnames';

import StarIcon from 'components/assets/icons/StarIcon';

export default class StarsBar extends Component {
    static propTypes = {
        value: PropTypes.number,
        count: PropTypes.number,
        className: PropTypes.string,
        notSelectedfill: PropTypes.string,
        selectedFill: PropTypes.string,
        onChange: PropTypes.func
    };

    static defaultProps = {
        count: 5,
        value: 0,
        notSelectedfill: '#a6b0bd',
        selectedFill: '#fbc100'
    };

    render() {
        const {count, className} = this.props;

        const containerClassName = classNames(styles.container, className);

        return (
            <div className={containerClassName}>
                {_.range(count).map(this.renderStar)}
            </div>
        );
    }

    renderStar = index => {
        const {
            value,
            selectedFill,
            notSelectedfill,
            onChange
        } = this.props;

        const selected = index < value;

        const fill = selected ? selectedFill : notSelectedfill;

        const startClassName = classNames(styles.star, {
            [styles.starClickable]: this.canBeSelected()
        });

        const handleChange = _.partial(onChange || _.noop, index + 1);

        return (
            <div key={index}
                 className={startClassName}
                 onClick={handleChange}>
                <StarIcon className={styles.starIcon}
                          fill={fill}/>
            </div>
        );
    };

    canBeSelected() {
        return Boolean(this.props.onChange);
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/StarsBar.jsx